import React from 'react';
import { Layout as AntLayout } from 'antd';
import Header from './Header';
import { useAuthStore } from '../../store/useAuthStore';

const { Content } = AntLayout;

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return children;
  }

  return (
    <AntLayout className="min-h-screen">
      <Header />
      <Content className="flex-1">
        {children}
      </Content>
    </AntLayout>
  );
};

export default Layout;
